// Error components must be Client Components
'use client';

import { SiteError, SITES } from '@woonstad/ui-public-sites';

export default function ErrorPage(props: Parameters<typeof SiteError>[0]) {
  return (
    <SiteError
      {...props}
      site={SITES.Stadswonen}
    />
  );
}
